import { RouteObject } from 'react-router-dom'
import { lazy } from 'react'
import ModuleGuard from '@/core/guards/ModuleGuard.tsx'
import ErrorPage from '@/pages/errors/ErrorPage.tsx'

const SALES_ROUTES: RouteObject[] = [
  {
    path: 'sales',
    element: <ModuleGuard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'clients',
        lazy: async () => {
          const ClientsPage = lazy(
            () => import('@/pages/clients/ClientsPage.tsx')
          )
          return { element: <ClientsPage /> }
        }
      },
      {
        path: 'clients/:id',
        lazy: async () => {
          const ClientsDetailsPage = lazy(
            () => import('@/pages/clientDetails/ClientsDetailsPage.tsx')
          )
          return { element: <ClientsDetailsPage /> }
        }
      },
      {
        path: 'service-recharge-invoices',
        lazy: async () => {
          const ServiceRechargeInvoicesPage = lazy(
            () =>
              import(
                '@/pages/serviceRechargeInvoices/ServiceRechargeInvoicesPage.tsx'
              )
          )
          return { element: <ServiceRechargeInvoicesPage /> }
        }
      },
      {
        path: 'weppa-flex',
        lazy: async () => {
          const WeppaFlexPage = lazy(
            () => import('@/pages/weppaFlex/WeppaFlexPage.tsx')
          )
          return { element: <WeppaFlexPage /> }
        }
      }
    ]
  }
]

export default SALES_ROUTES
